import { Component } from '@angular/core';
import { LoCard } from 'lo-design-system';

@Component({
	standalone: true,
	selector: 'app-google-disclosure',
	imports: [LoCard],
	styles: [
		`
			:host {
				display: block;

				.desc {
					display: flex;
					flex-direction: column;
					gap: var(--lo-space-gap-lg);

					p {
						margin: 0;
						color: var(--lo-color-text-secondary);
					}

					a {
						color: var(--lo-color-text-link);
						text-decoration: none;

						&:hover {
							color: var(--lo-color-text-link-hover);
							text-decoration: underline;
						}
					}
				}
			}
		`
	],
	template: `
		<lo-card heading="Disclosure">
			<div class="desc lo-type-text-sm">
				<p>
					Lolly strictly uses Google’s Application Programming
					Interface (API) Services to send emails to the creator on
					your behalf and to read any reply made by the creator to the
					sent email. Lolly’s use and transfer to any other app of
					information received from Google APIs will adhere to
					<a
						href="https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes"
						target="_blank"
					>
						Google API Services User Data Policy
					</a>
					, including the
					<a
						href="https://support.google.com/cloud/answer/9110914#explain-types&zippy=%2Ccould-you-explain-the-limited-use-requirements-from-the-google-api-services-user-data-policy"
						target="_blank"
					>
						Limited Use Requirements.
					</a>
				</p>
				<p>
					We value and understand the security and privacy of your
					google account, hence we maintain and comply with the Google
					API Services User Data Policy. Refer to our
					<a href="https://www.lolly.com/privacy/" target="_blank">
						Privacy Policy
					</a>
					for more information regarding the use of Lolly.com platform
					and its services.
				</p>
				<p>
					Lolly assures that your Google account is used to facilitate
					better communication between you and the creator as a part
					of our CRM (creator relationship management).
				</p>
			</div>
		</lo-card>
	`
})
export class GoogleDisclosureComponent {}
